import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { addressEndpoint, shipmentEndpoint } from 'src/app/utils/constants/requestUrl';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  post() {
    throw new Error('Method not implemented.');
  }
  constructor(private http: HttpClient) {}

  getAddressList(data): Observable<any> {
    return this.http.post(`${environment.AddressUrl}${addressEndpoint.getAddressList}`, data);
  }

  updateAddress(data, id = ''): Observable<any> {
    if (id) {
      data._id = id;
    }
    return this.http.post(`${environment.AddressUrl}${addressEndpoint.updateAddress}`, data);
  }

  uploadAddress(data): Observable<any> {
    return this.http.post(`${environment.AddressUrl}${addressEndpoint.importAddress}`, data);
  }

  createAddress(data): Observable<any> {
    return this.http.post(`${environment.AddressUrl}${addressEndpoint.createAddress}`, data);
  }

  deleteAddress(requestBody): Observable<any> {
    return this.http.delete(
      `${environment.AddressUrl}${addressEndpoint.deleteAddress}`,
      requestBody
    );
  }

  getPostalCodeServiceableArea(countryCode, cityName?, postalCode?) {
    let params = new HttpParams();
    params = params.append('countryCode', countryCode);

    if (postalCode) {
      params = params.append('postalCode', postalCode);
    }

    if (cityName) {
      params = params.append('city', cityName);
    }

    return this.http.get(`${environment.AddressUrl}${addressEndpoint.getPostalList}`, {
      params,
    });
  }
  // Download sheet
  getAddressSheet(customerId: string, customerRole: string) {
    let params = new HttpParams();
    params = params.append('Currentcustomerid', customerId);
    params = params.append('Currentuserrole', customerRole);
    return this.http.get(`${environment.AddressUrl}${addressEndpoint.getAddressSheet}`, {
      params,
    });
  }

  getAddressUploadList() {
    const requestBody = {
      dateRange: {
        dateField: 'upload_datetime',
        fromDate: '20230812',
        toDate: '20230819',
      },
    };
    return this.http.post(
      `${environment.shipmentUrl}${shipmentEndpoint.fileUploadStatus}`,
      requestBody
    );
  }
}
